(() => {
    let tabButtons = document.querySelectorAll('.diu-tabs-list-button');

    const initStateReady = () => {
        if (tabButtons) {
            tabButtons.forEach((tabBtn, index) => {
                // default activate first record
                if (index === 0) {
                    activateTab(tabBtn);
                }

                // if url param set, activate tab
                activateTabByUrlParam(tabBtn);

                tabBtn.addEventListener('click', function (event) {
                    activateTab(tabBtn);
                });
            });
        }
    };

    const activateTab = (tabBtn) => {
        resetTabs();
        toggleTab(tabBtn.getAttribute('data-section-id'), tabBtn, true);
    };

    const resetTabs = () => {
        tabButtons.forEach((tabBtn) => {
            toggleTab(tabBtn.getAttribute('data-section-id'), tabBtn, false);
        });
    };

    const activateTabByUrlParam = (tabBtn) => {
        var searchUrl = new URL(window.location);

        searchUrl.searchParams.forEach(function (val, key) {
            if (key.startsWith('tabId')) {
                if (val === tabBtn.getAttribute('data-section-id')) {
                    activateTab(tabBtn);
                }
            }
        });
    };

    const toggleTab = (sectionId, tabBtn, addClassToTab) => {
        if (sectionId && tabBtn) {
            if (addClassToTab) {
                tabBtn.classList.add('active');
                document.querySelector('#' + sectionId).classList.add('active');
            } else {
                tabBtn.classList.remove('active');
                document.querySelector('#' + sectionId).classList.remove('active');
            }
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
